import React from 'react'
import HeroSection from './HeroSection';
import Breadcrumb from './Breadcrumb';


function Clients() {
  return (
    <div className='aboutInfo'>
    <div>
    {/* Reusable Hero Section */}
    <HeroSection
      heading="Clients"
      backgroundImage="/img/software2.jpg"
    />

    <Breadcrumb />



    <div className='customers'>
          <h1 className='customer-h'> OUR MAJOR CUSTOMERS</h1>
          <div className="customer-gallery">
    {/* Add customer logos */}
    <img src="/img/osrtc.png" alt="Customer 1" className="customer-logo" />
    <img src="/img/mg.jpeg" alt="Customer 2" className="customer-logo" />
    <img src="/img/ashok.png" alt="Customer 5" className="customer-logo" />
    <img src="/img/global.png" alt="Customer 6" className="customer-logo" />
    <img src="/img/eicher.png" alt="Customer 7" className="customer-logo" />
    <img src="/img/prakash.png" alt="Customer 8" className="customer-logo" />
    <img src="/img/chartered.jpeg" alt="Customer 9" className="customer-logo" />
  </div>
  </div>


    </div>
    </div>
  )
}

export default Clients;